import React, { useState, useEffect } from 'react';
import Home from './pages/Home';
import Recent from './pages/Recent';
import Champions from './pages/Champions';
import { UserProfile } from './pages/UserProfile';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<string>('/');

  useEffect(() => {
    // Function to handle hash changes
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || '/';
      setCurrentPage(hash);
    };

    // Set initial page based on current hash
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // Render the appropriate page based on current route
  const renderPage = () => {
    // Handle user profile routes with dynamic address parameter
    if (currentPage.startsWith('/user/')) {
      const address = currentPage.split('/user/')[1];
      return <UserProfile address={address} />;
    }

    switch (currentPage) {
      case '/':
        return <Home />;
      case '/recent':
        return <Recent />;
      case '/champions':
        return <Champions />;
      default:
        return <Home />; // Default to home for unknown routes
    }
  };

  return (
    <div className="App min-h-screen flex flex-col">
      <div className="flex-grow">
        {renderPage()}
      </div>
      <footer className="py-6 text-center border-t border-slate-800/50 bg-slate-900">
        <div className="flex flex-col gap-1">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} Shido Gateway Leaderboard. All rights reserved.
          </p>
          <p className="text-xs text-slate-500 font-medium opacity-80">
            Powered by MavNode Labs 🧪
          </p>
        </div>
      </footer>
    </div>
  );
};

export default App;
